export const TICKET_LIST_ACTION = "TICKET_LIST_ACTION";
export const TICKET_LIST_SUCCESS = "TICKET_LIST_SUCCESS";

export const TICKET_DETAIL_ACTION = "TICKET_DETAIL_ACTION";
export const TICKET_DETAIL_SUCCESS = "TICKET_DETAIL_SUCCESS";

export const TICKET_UPDATE_ACTION = "TICKET_UPDATE_ACTION";
export const TICKET_UPDATE_SUCCESS = "TICKET_UPDATE_SUCCESS";

// MY TICKET

export const TICKET_MY_LIST_ACTION = "TICKET_MY_LIST_ACTION";
export const TICKET_MY_LIST_SUCCESS = "TICKET_MY_LIST_SUCCESS";

export const TICKET_MY_DETAIL_ACTION = "TICKET_MY_DETAIL_ACTION";
export const TICKET_MY_DETAIL_SUCCESS = "TICKET_MY_DETAIL_SUCCESS";

export const TICKET_MY_UPDATE_ACTION = "TICKET_MY_UPDATE_ACTION";
export const TICKET_MY_UPDATE_SUCCESS = "TICKET_MY_UPDATE_SUCCESS";

// TICKET ASSIGN CONFIG

export const TICKET_ASSIGN_CONFIG_LIST_ACTION = "TICKET_ASSIGN_CONFIG_LIST_ACTION";
export const TICKET_ASSIGN_CONFIG_LIST_SUCCESS = "TICKET_ASSIGN_CONFIG_LIST_SUCCESS";

export const TICKET_ASSIGN_CONFIG_DETAIL_ACTION = "TICKET_ASSIGN_CONFIG_DETAIL_ACTION";
export const TICKET_ASSIGN_CONFIG_DETAIL_SUCCESS = "TICKET_ASSIGN_CONFIG_DETAIL_SUCCESS";

export const TICKET_ASSIGN_CONFIG_CREATE_ACTION = "TICKET_ASSIGN_CONFIG_CREATE_ACTION";
export const TICKET_ASSIGN_CONFIG_CREATE_SUCCESS = "TICKET_ASSIGN_CONFIG_CREATE_SUCCESS";

export const TICKET_ASSIGN_CONFIG_DELETE_ACTION = "TICKET_ASSIGN_CONFIG_DELETE_ACTION";
export const TICKET_ASSIGN_CONFIG_DELETE_SUCCESS = "TICKET_ASSIGN_CONFIG_DELETE_SUCCESS";

export const TICKET_ASSIGN_CONFIG_UPDATE_ACTION = "TICKET_ASSIGN_CONFIG_UPDATE_ACTION";
export const TICKET_ASSIGN_CONFIG_UPDATE_SUCCESS = "TICKET_ASSIGN_CONFIG_UPDATE_SUCCESS";

export const TICKET_FAIL = "TICKET_FAIL";
